import { render, staticRenderFns } from "./tariff.vue?vue&type=template&id=cb91a50e&"
import script from "./tariff.vue?vue&type=script&lang=js&"
export * from "./tariff.vue?vue&type=script&lang=js&"
import style0 from "./tariff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tariff.vue"
export default component.exports